import { HighlightCard } from '@/components';
import { useDerivedNetworkContext } from '@/context';
import { usePayoutsQuery } from '@/services/revenueApi';
import { YearString } from '@/types/state/filter';
import { formatCurrency } from '@/utils/currencyUtils';
import { getCurrentYear, getCurrentQuarter } from '@/utils/dateUtils';

export const QuarterlyTotals = ({ year }: { year: YearString }) => {
  const { selectedNetwork } = useDerivedNetworkContext();
  const payouts = usePayoutsQuery(selectedNetwork.id ?? '', year);
  const { data, isPending, isError } = payouts;

  const currentQuarter = getCurrentQuarter();
  const isCurrentYear = year === getCurrentYear();

  if (payouts) {
    if (isError) {
      return null; // Error message displayed in PayoutsCard
    }
  }

  return (
    <>
      {data && (
        <div className="grid grid-cols-12 grid-rows-2 xl:grid-cols-10 xl:grid-rows-1 gap-2 xl:gap-6">
          <div className="col-span-12 xl:col-span-8 row-span-1 row-start-2 xl:row-start-1 overflow-x-auto xl:overflow-x-hidden hide-scrollbar">
            <div className="flex gap-2 xl:gap-6">
              {(['1', '2', '3', '4'] as const).map((quarter) => {
                const total = data?.quarterly_totals[quarter];
                const isFuture = isFutureQuarter(parseInt(quarter), parseInt(year), currentQuarter);

                return (
                  <HighlightCard
                    key={`Q${quarter}`}
                    title={
                      isCurrentYear && Number(quarter) === currentQuarter
                        ? `Sent in Q${quarter} to date`
                        : `Sent in Q${quarter}`
                    }
                    className="w-[45%] lg:max-w-[234px] xl:max-w-[244px] pt-0"
                    loading={isPending || !data}
                    value={isFuture ? '-' : formatCurrency(total.amount, total.currency).toString()}
                  />
                );
              })}
            </div>
          </div>
          <HighlightCard
            title={`${year ?? ''} total${isCurrentYear ? ' to date' : ''}`}
            loading={isPending || !data}
            className="col-span-12 xl:col-span-2 pt-0"
            value={formatCurrency(
              data?.quarterly_totals?.year.amount,
              data?.quarterly_totals?.year.currency
            ).toString()}
          />
        </div>
      )}
    </>
  );
};
const isFutureQuarter = (quarter: number, year: number, currentQuarter: number): boolean => {
  const currentYear = Number(getCurrentYear())

  if (year < currentYear) {
    return false;
  }

  if (year === currentYear) {
    return quarter > currentQuarter;
  }

  return true;
};
